import React, { useEffect, useState, memo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { ZapIcon, ClockIcon, ArrowRightIcon } from 'lucide-react';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export const FlashSales = memo(function FlashSales() {
  const [searchParams] = useSearchParams();
  const isNowContext = searchParams.get('from') === 'now';
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 4,
    minutes: 57,
    seconds: 10
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          days,
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        return {
          days,
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const products = [{
    id: 1,
    name: 'Optimum Nutrition Gold Standard 100% Whey Protein',
    brand: 'Optimum Nutrition',
    price: 29.99,
    originalPrice: 69.99,
    discount: 62,
    rating: 4.8,
    reviewCount: 2456,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'C4 Original Pre-Workout Powder',
    brand: 'Cellucor',
    price: 24.99,
    originalPrice: 49.99,
    discount: 50,
    rating: 4.7,
    reviewCount: 1823,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Dymatize ISO100 Hydrolyzed Protein',
    brand: 'Dymatize',
    price: 34.99,
    originalPrice: 64.99,
    discount: 46,
    rating: 4.9,
    reviewCount: 3102,
    image: PRODUCT_IMAGES[2],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'MuscleTech Nitro-Tech Whey Protein',
    brand: 'MuscleTech',
    price: 27.99,
    originalPrice: 54.99,
    discount: 49,
    rating: 4.6,
    reviewCount: 1567,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 5,
    name: 'BSN Syntha-6 Protein Powder',
    brand: 'BSN',
    price: 31.99,
    originalPrice: 59.99,
    discount: 47,
    rating: 4.7,
    reviewCount: 2234,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Optimum Nutrition Amino Energy',
    brand: 'Optimum Nutrition',
    price: 19.99,
    originalPrice: 34.99,
    discount: 43,
    rating: 4.5,
    reviewCount: 1890,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / (isNowContext ? 3 : 2));
  return <div className="w-full" data-id="element-2437" data-mp="29tgwhxv3b6m8">
      <div className="container mx-auto px-4" data-id="element-2438" data-mp="29ua6r8t9ce94">
        <div className="bg-gradient-to-r from-red-600 to-orange-600 rounded-xl overflow-hidden mb-6" data-id="element-2439" data-mp="29re8tkhetpko">
          <div className="p-4 md:p-6 text-white" data-id="element-2440" data-mp="2dszlp5ty23uv">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2441" data-mp="31jlr0pckda16">
              <div className="mb-4 md:mb-0" data-id="element-2442" data-mp="36ceuzb07kec7">
                <span className="text-xs font-bold text-white bg-white bg-opacity-20 px-2 py-0.5 rounded-full mb-2 inline-block uppercase" data-id="element-2443" data-mp="36dhhz7uetwmu">
                  LIMITED TIME OFFERS
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-white flex items-center" data-id="element-2444" data-mp="1dqbhdkcmxdec">
                  <ZapIcon className="w-6 h-6 md:w-8 md:h-8 mr-2" data-id="element-2445" data-mp="18qylyb7p6y05" />
                  FLASH SALES
                </h2>
              </div>
              <div className="flex items-center gap-4" data-id="element-2446" data-mp="21e2rqiem7gcz">
                <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-full px-4 py-2" data-id="element-2447" data-mp="21fnngbco15cf">
                  <ClockIcon className="w-4 h-4" data-id="element-2448" data-mp="1wgjd3he091ki" />
                  <div className="flex items-center gap-1 font-mono font-bold" data-id="element-2449" data-mp="1rmon5w7t3qcz">
                    <span data-id="element-2450" data-mp="1nmo94comdh6g">{String(timeLeft.hours).padStart(2, '0')}</span>
                    <span data-id="element-2451" data-mp="1nkbry1qoraug">:</span>
                    <span data-id="element-2452" data-mp="2k4aqypf71mnw">{String(timeLeft.minutes).padStart(2, '0')}</span>
                    <span data-id="element-2453" data-mp="2fdc6rer344fd">:</span>
                    <span data-id="element-2454" data-mp="2fc9i7dh8ie2m">{String(timeLeft.seconds).padStart(2, '0')}</span>
                  </div>
                </div>
                <a href="#" className="text-white bg-white bg-opacity-20 hover:bg-opacity-30 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center flex-shrink-0" data-id="element-2455" data-mp="1w97y0wxqd8l">
                  View All
                  <ArrowRightIcon className="w-4 h-4 ml-1" data-id="element-2456" data-mp="fupmuf4yba1t" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Slider */}
        {isMobile ? <div className="relative" data-id="element-2457" data-mp="prtyvm531p4w">
            <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-2458" data-mp="pqsprn7mncpt">
              {products.map((product, idx) => <motion.div key={product.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05,
            duration: 0.4
          }} className="snap-start flex-shrink-0" style={{
            width: isNowContext ? 'calc(33.333% - 8px)' : 'calc(50% - 6px)'
          }} data-id="element-2459" data-mp="18gs7tq51vrjq" data-mpi={idx}>
                  <EnhancedProductCard product={product} data-id="element-2460" data-mp="136okdlmv6lq" />
                </motion.div>)}
            </div>
            {/* Pagination Dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-2461" data-mp="22xp5phb4slw3">
              {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => {
            haptics.selection();
            scrollToSlide(index);
          }} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-2462" data-mp="df8rdyk5qr7k" data-mpi={index} />)}
            </div>
          </div> :
      // Desktop Grid
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-id="element-2463" data-mp="3vtrsidxrs18k">
            {products.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          duration: 0.4
        }} data-id="element-2464" data-mp="3gxk8peq9x1tt" data-mpi={idx}>
                <EnhancedProductCard product={product} data-id="element-2465" data-mp="2v929o66vqjz" />
              </motion.div>)}
          </div>}
      </div>
    </div>;
});